import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { FiAlertCircle, FiX } from "react-icons/fi";

const slideIn = keyframes`
  from { opacity: 0; transform: translate(-50%, -10px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
`;

const slideOut = keyframes`
  from { opacity: 1; transform: translate(-50%, 0); }
  to   { opacity: 0; transform: translate(-50%, -10px); }
`;

const Toast = styled.div`
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.danger};
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.shadow.md};
  color: ${({ theme }) => theme.colors.text};
  z-index: 100;
  max-width: 90vw;
  animation: ${({ leaving }) => (leaving ? slideOut : slideIn)} 220ms ease forwards;

  .icon {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.colors.danger};
  }

  .close {
    background: transparent;
    border: 0;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.textMuted};
    display: inline-flex;
    align-items: center;
    padding: 4px;
    border-radius: 6px;
    &:hover { background: ${({ theme }) => theme.colors.bgAlt}; color: ${({ theme }) => theme.colors.text}; }
  }
`;

const ErrorNotification = ({ message, duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!duration) return;
    const leaveTimer = setTimeout(() => setLeaving(true), Math.max(0, duration - 220));
    const closeTimer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);
    return () => {
      clearTimeout(leaveTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <Toast role="alert" leaving={leaving}>
      <FiAlertCircle className="icon" />
      <span>{message}</span>
      <button
        className="close"
        onClick={() => { setVisible(false); onClose?.(); }}
        aria-label="Dismiss"
      >
        <FiX size={16} />
      </button>
    </Toast>
  );
};

export default ErrorNotification;
